export default __webpack_public_path__ + "static/media/T1.e3ca6248.mp4";